import { PROGRESS_STATUS } from '../../../../../../consts/enums';

export const style = {
  typograpyStatus: {
    sx: {
      color: 'action.active',
      lineHeight: 2,
    },
  },
  typograpyDesc: {
    sx: {
      color: 'text.secondary',
      opacity: 0.6,
    },
  },
  box: {
    sx: {
      display: 'flex',
      alignItems: 'start',
      color: 'action.active',
      gap: 1,
      pt: 1,
      pb: 0,
    },
  },
  svg: {
    [PROGRESS_STATUS.COMPLETED]: {
      fill: '#0B815A',
    },
    [PROGRESS_STATUS.DEGRADED]: {
      fill: '#F1C40F',
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
} as const;
